import styled from "styled-components";
import { designSystemVars as vars } from "../tokens";

export const PersonListPopover = styled.div<{
  width?: number;
  $embedded?: boolean;
}>`
  display: flex;
  width: ${({ width, $embedded }) =>
    $embedded ? "100%" : width ? `${width}px` : "333px"};
  height: auto;
  min-height: 0;
  max-height: 300px;
  align-self: stretch;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: auto;
  padding: var(--inzeloop-ds-spacing-md);
  margin-bottom: ${({ $embedded }) =>
    $embedded ? "0" : "var(--inzeloop-ds-spacing-10px)"};
  border-right: ${({ $embedded }) =>
    $embedded
      ? "none"
      : `${vars.borderWidth.medium} solid ${vars.color.border.accent}`};
  border-bottom: ${({ $embedded }) =>
    $embedded
      ? "none"
      : `${vars.borderWidth.medium} solid ${vars.color.border.accent}`};
  border-left: ${({ $embedded }) =>
    $embedded
      ? "none"
      : `${vars.borderWidth.medium} solid ${vars.color.border.accent}`};
  border-radius: ${({ $embedded }) =>
    $embedded ? "0" : `0 0 ${vars.radius.sm} ${vars.radius.sm}`};
  background: ${vars.color.background.surface};
  box-shadow: ${({ $embedded }) => ($embedded ? "none" : vars.shadow.dropdown)};
`;

export const PersonListOption = styled.div<{ $disabled?: boolean }>`
  display: flex;
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--inzeloop-ds-spacing-1px);
  padding: 0 ${vars.spacing.lg} 0 var(--inzeloop-ds-spacing-5px);
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "default")};
  transition: background-color ${vars.motion.normal} ${vars.motion.easing};

  &:hover {
    background: ${({ $disabled }) =>
      $disabled ? vars.color.border.transparent : vars.color.border.subtle};
  }
`;

export const DisabledPersonOption = styled.div`
  width: 100%;
  flex: 0 0 auto;
`;

export const PersonOptionName = styled.div`
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  color: ${vars.color.text.primary};
  font-family: ${vars.typography.family.sans};
  font-size: ${vars.typography.size.md};
  font-weight: ${vars.typography.weight.regular};
  line-height: var(--inzeloop-ds-line-height-lg);
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PersonOptionAvatar = styled.img`
  display: flex;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 var(--inzeloop-ds-spacing-5-5px);
  border-radius: ${vars.radius.full};
  aspect-ratio: 1 / 1;
`;

export const PersonOptionRow = styled.div`
  display: flex;
  width: 100%;
  min-height: 38px;
  align-items: center;
  gap: ${vars.spacing.sm};
  box-sizing: border-box;
  padding: var(--inzeloop-ds-spacing-6px) 0;
  background: var(--inzeloop-ds-color-background-transparent);

  > svg {
    flex: 0 0 auto;
  }
`;
